enum Phase {
  Backlog = 'backlog',
  Blocked = 'blocked',
  Wip = 'wip',
  Review = 'review',
  Test = 'test',
  Deployable = 'deployable',
  Done = 'done',
}

type PhaseMetadataItem = {
  id: Phase;
  label: string;
  color: string;
  description: string;
};

export { Phase };
export type { PhaseMetadataItem };
